import forDevice from '../../hoc/for-device';
import PostMainActionsDesktop from './post-main-actions-desktop';
import PostMainActionsMobile from './post-main-actions-mobile';

export default forDevice(PostMainActionsMobile, PostMainActionsDesktop);
